import React from 'react';

export function CultureIcon() {
  return (
    <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M11.23 4.801c0 2.284-2.227 4.135-2.227 4.135S6.778 7.085 6.778 4.801c0-2.283 2.225-4.135 2.225-4.135s2.227 1.851 2.227 4.135zM15.062 15.058C12.761 17.364 9 17.33 9 17.33s-.035-3.765 2.267-6.067c2.302-2.301 6.067-2.266 6.067-2.266s.03 3.767-2.27 6.062z"
        stroke="#fff"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M2.933 15.058C5.235 17.364 9 17.33 9 17.33s.034-3.765-2.267-6.067C4.43 8.961.667 8.996.667 8.996s-.036 3.767 2.266 6.062z"
        stroke="#fff"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.003 8.936v8.392"
        stroke="#fff"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
